import { http } from "./http";

export type UsuarioAdmin = {
  id: number;
  nombre: string;
  email: string;
  telefono: string | null;
  activo: boolean;
  creadoEn: string; // ISO
  roles: string[];
};

export type CrearUsuarioRequest = {
  nombre: string;
  email: string;
  telefono?: string | null;
  password: string;
  rol: string; // "EVENT_ADMIN" | "SYSTEM_ADMIN" etc
};

export type CambiarEstadoRequest = {
  activo: boolean;
};

export async function listarUsuarios() {
  return http.request<UsuarioAdmin[]>("/api/admin/usuarios", {
    method: "GET",
    auth: "basic",
  });
}

export async function crearUsuario(payload: CrearUsuarioRequest) {
  return http.request<UsuarioAdmin>("/api/admin/usuarios", {
    method: "POST",
    body: payload,
    auth: "basic",
  });
}

export async function cambiarEstadoUsuario(userId: number, activo: boolean) {
  return http.request<UsuarioAdmin>(`/api/admin/usuarios/${userId}/estado`, {
    method: "PATCH",
    body: { activo } satisfies CambiarEstadoRequest,
    auth: "basic",
  });
}